export enum ErrorTypes {
  POST_ORDER_UNKNOWN = 'POST_ORDER_UNKNOWN_ERROR',
  POST_ORDER_ERROR = 'POST_ORDER_ERROR',
  XML_DROP_ERROR = 'XML_DROP_ERROR',
  XML_MAP_ERROR = 'XML_MAP_ERROR',
  CSV_DROP_ERROR = 'CSV_DROP_ERROR',
  CSV_MAP_ERROR = 'CSV_MAP_ERROR',
  LOGIN_ERROR = 'LOGIN_ERROR',
  YUP_LOCALE = 'YUP_LOCALE_ERROR',
  ORDER_IS_NOT_SUPPLY = 'ORDER_IS_NOT_SUPPLY',
  SUPPLY_IS_NOT_ENABLED_TO_SELLER_GROUP = 'SUPPLY_IS_NOT_ENABLED_TO_SELLER_GROUP',
  SELLER_DESTINATION_NOT_BELONGS_THE_SELLER_GROUP = 'SELLER_DESTINATION_NOT_BELONGS_THE_SELLER_GROUP',
  SELLER_CD_NOT_BELONGS_THE_SELLER_GROUP = 'SELLER_CD_NOT_BELONGS_THE_SELLER_GROUP',
  SELLER_ORIGIN_AND_SELLER_DESTINATION_ARE_THE_SAME = 'SELLER_ORIGIN_AND_SELLER_DESTINATION_ARE_THE_SAME',
  SELLER_ORIGIN_AND_SELLER_CD_ARE_THE_SAME = 'SELLER_ORIGIN_AND_SELLER_CD_ARE_THE_SAME',
  SELLER_DESTINATION_AND_SELLER_CD_ARE_THE_SAME = 'SELLER_DESTINATION_AND_SELLER_CD_ARE_THE_SAME',
  DUPLICATE_ORDER = 'DUPLICATE_ORDER',
  DRIVER_TAG_LABEL_ALREADY_EXISTS = 'DRIVER_TAG_LABEL_ALREADY_EXISTS',
  SELLER_TAG_LABEL_ALREADY_EXISTS = 'SELLER_TAG_LABEL_ALREADY_EXISTS',
  ROUTE_TAG_LABEL_ALREADY_EXISTS = 'ROUTE_TAG_LABEL_ALREADY_EXISTS',
}

export type AbbiamoError = {
  code: string;
  error_id: string;
  message: string;
  status_code: number;
  timestamp: string;
  params?: any
};
